<ng-container *ngIf="target">
  <a type="button" class="btn btn-secondary" [routerLink]="route">
    <i class="ft-list mr-1"></i>
    <span translate>List</span>
  </a>
</ng-container>
